import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Wrapper } from "./styled";
import ButtonTextOnly from "../../../../../../commons/Buttons/ButtonTextOnly";
import colors from "../../../../../../../styles/colorPalette";
import {
  captcha,
  internalId,
  payment,
  totalAmount,
  selectedArticles,
} from "../../../../../../../store/Concept/selectors";
import { paymentRequest } from "../../../../../../../store/Concept/actions";
import { getPaymentFormat } from "../../../../functions";
import { redirectTo } from "../../../../../../../utils/functions";
import { isDisabled } from "./functions";

const PaymentButton = ({ detail }) => {
  const dispatch = useDispatch();
  const interId = useSelector(internalId);
  const intId = useSelector(internalId);
  const total = useSelector(totalAmount);
  const paymentReq = useSelector(payment);
  const captchaValue = useSelector(captcha);
  const items = useSelector(selectedArticles);
  const tot = parseInt(total);
  const cero = items.length === 0 || tot === 0;

  const generateRequest = () => {
    if (!paymentReq) {
      dispatch(paymentRequest(getPaymentFormat(total, intId, interId)));
    } else {
      redirectTo(paymentReq.checkout_url);
    }
  };

  return (
    <Wrapper>
      <ButtonTextOnly
        onClick={() => generateRequest()}
        fontSize={"14px"}
        background={colors.blue1}
        color={colors.gray1}
        text={"Pagar"}
        disabled={isDisabled(detail, captchaValue, cero)}
      />
    </Wrapper>
  );
};

export default PaymentButton;
